import { bootstrapApplication } from "@angular/platform-browser";
import { initSentry } from "./app/libs/sentry";
import { appConfig } from "./app/app.config";
import { App } from "./app/app.component";

initSentry();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
